import React from 'react';

class Newsletter extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
    document.body.appendChild(script);

    script.onload = () => {
      const func = document.createElement('script');
      func.type = 'text/javascript';
      func.innerHTML = '(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]="EMAIL";ftypes[0]="email";}(jQuery));var $mcj = jQuery.noConflict(true);';
      document.body.appendChild(func);
    };
  }

  render() {
    return (
      <div className="l-newsletter">
        <div id="mc_embed_signup" className="email-subscription">
          <form
            action="//resourcegovernance.us2.list-manage.com/subscribe/post?u=586ab656ca1263b8776b1f081&amp;id=81af06e868"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            className="validate"
            target="_blank"
            noValidate
          >
            <div id="mc_embed_signup_scroll">
              <span className="subscription-title">Subscribe to news and analysis from NRGI</span>
              {/* <div className="indicates-required"><span className="asterisk">*</span> indicates required</div> */}
              <div className="mc-field-group subscription-box">
                <input type="email" name="EMAIL" className="required email subscribe-input" id="mce-EMAIL" placeholder="EMAIL ADDRESS" />
                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button subscribe-button" />
              </div>
              <div id="mce-responses" className="clear">
                <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
              </div>
              <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                <input type="text" name="b_586ab656ca1263b8776b1f081_81af06e868" tabIndex="-1" value="" />
              </div>
            </div>
          </form>
        </div>
        {/* Scripts */}
        <div ref={el => (this.scripts = el)}></div>
      </div>
    );
  }
}

Newsletter.propTypes = {
  // router: React.PropTypes.object.isRequired
};

export default Newsletter;



// WEBPACK FOOTER //
// ./app/components/common/Newsletter.jsx